/* ==========================================================================
   Savwinch mobile menu: expand before navigate

   Wave's mobile hamburger drawer (menu-hamburger-base.liquid) splits each
   top-level row into two separate tap targets: the label text is a plain
   <a href> that navigates immediately, and a small chevron icon opens the
   mega-menu sub-links via a hidden <xo-modal-trigger>. Shoppers expect the
   whole row to reveal the sub-links first (matching desktop hover), with
   direct navigation to the collection still available via the "Shop All..."
   link already present inside each opened panel.

   This intercepts a tap on the label link and, only when that item actually
   owns mega-menu content (same detection as sav-mega-menu.js's hasPanel()),
   cancels the navigation and clicks the sibling modal-trigger instead. An
   item with no mega-menu content (eg. Installation Gallery) still navigates
   immediately, since there is nothing to expand.

   Loaded once from layout/theme.liquid; self-guards on
   window.__savMobileMenuExpand.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__savMobileMenuExpand) return;
  window.__savMobileMenuExpand = true;

  var ITEM_SELECTOR = '.xo-menu-hamburger-base__item';
  var CONTAINER_SELECTOR = '.xo-menu-hamburger-base__link--level-1';
  // The label link sits several levels deep inside the level-1 container
  // (Wave's text-animation wrapper splits it into nested spans), not as a
  // direct child, so this must be a descendant selector.
  var LABEL_SELECTOR = CONTAINER_SELECTOR + ' a[href]';

  function hasPanel(item) {
    var mega = item.querySelector('xo-mega-menu');
    if (!mega) return false;

    // Already cloned in by <xo-mega-menu>.
    if (mega.children.length > 0 || mega.hasAttribute('xo-section-id')) return true;

    // Not cloned yet (lazy clone on first open). Ask the source template
    // instead, same as sav-mega-menu.js does for the desktop hover nav.
    var index = mega.getAttribute('xo-index');
    var name = mega.getAttribute('xo-name') || 'header-mega-menu';
    if (index === null) return false;

    var sel = 'template[xo-mega-menu-name="' + name + '"][xo-mega-menu-index="' + index + '"]';
    return !!document.querySelector(sel);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest(LABEL_SELECTOR);
      if (!link) return;

      var container = link.closest(CONTAINER_SELECTOR);
      var item = link.closest(ITEM_SELECTOR);
      if (!container || !item) return;

      if (!hasPanel(item)) return; // plain link, nothing to expand: let it navigate

      var trigger = container.querySelector('xo-modal-trigger');
      if (!trigger) return;

      event.preventDefault();
      trigger.click();
    },
    true
  );
})();
